"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _sumBy2 = _interopRequireDefault(require("lodash/sumBy"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _hotelDetails = require("../clients/hotel-details.client");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _aboutHotel = require("../utils/about-hotel.utils");
var _language = require("../utils/language.utils");
var _topPick = require("../factories/topPick.factory");
var _hotelInfo = require("../factories/hotel-info.factory");
var _error = _interopRequireDefault(require("../factories/error.factory"));
var _hotel = require("../utils/hotel.utils");
var _seo = require("../utils/seo.utils");
var _constants2 = require("../constants");
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/**
 * hotel info store
 */
var HotelInfoStore = exports["default"] = (_dec = _mobx.observable.shallow, _dec2 = _mobx.action.bound, _class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function HotelInfoStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var $env = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2["default"])(this, HotelInfoStore);
    (0, _initializerDefineProperty2["default"])(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "API_STATE", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "language", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "isRtl", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "isDev", _descriptor5, this);
    /**
     * fetch hotel info
     * @param {Number} hotelId
     * @param {String} searchId
     * @param {Number} timeout in ms
     * @param {Function} errorHandler
     * @param {Function} successHandler // success handler
     */
    (0, _initializerDefineProperty2["default"])(this, "fetch", _descriptor6, this);
    this.$env = $env;
    this.updateInitialState(initialState);
  }
  return (0, _createClass2["default"])(HotelInfoStore, [{
    key: "isLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function get() {
      return this.API_STATE === _constants.API_STATE.LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isFetched",
    get: function get() {
      return this.API_STATE === _constants.API_STATE.SUCCESS;
    }

    /**
     * has error
     * @return {boolean}
     */
  }, {
    key: "hasError",
    get: function get() {
      return this.API_STATE === _constants.API_STATE.FAILED;
    }

    /**
     * hotel id
     * @return {String|undefined}
     */
  }, {
    key: "hotelId",
    get: function get() {
      return (0, _get2["default"])(this.data, 'atgHotelId');
    }

    /**
     * hotel FAQ
     * @return {Array}
     */
  }, {
    key: "FAQ",
    get: function get() {
      return (0, _hotelInfo.localizedFAQList)({
        list: (0, _get2["default"])(this.data, 'faq', []),
        isRtl: this.isRtl
      });
    }

    /**
     * hasFAQs
     * @return {Array}
     */
  }, {
    key: "hasFAQs",
    get: function get() {
      return this.FAQ.length > 0;
    }

    /**
     * hotel name
     * @return {String}
     */
  }, {
    key: "name",
    get: function get() {
      return (0, _language.translate2keysLabel)((0, _get2["default"])(this.data, 'hotel'), 'hotelName', this.language);
    }

    /**
     * hotel email
     * @return {String}
     */
  }, {
    key: "email",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.email');
    }

    /**
     * hotel phone
     * @return {String}
     */
  }, {
    key: "phone",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.phone');
    }

    /**
     * meta title
     * @return {String}
     */
  }, {
    key: "metaTitle",
    get: function get() {
      return (0, _seo.metaTitleSeo)(this.name, this.city, this.isRtl);
    }

    /**
     * chain id
     * @return {Number}
     */
  }, {
    key: "chainId",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.chain');
    }

    /**
     * hotel city
     * @return {String}
     */
  }, {
    key: "city",
    get: function get() {
      return (0, _language.translate2keysLabel)((0, _get2["default"])(this.data, 'hotel.location.city'), 'name', this.language);
    }

    /**
     * hotel has arabic spoken staff
     * @return {String}
     */
  }, {
    key: "hasArabicSpokenStaff",
    get: function get() {
      return (0, _aboutHotel.isArabicLanguagePresent)((0, _get2["default"])(this.spokenLanguages, 'list', []));
    }

    /**
     * hotel country
     * @return {String}
     */
  }, {
    key: "country",
    get: function get() {
      return (0, _language.translate2keysLabel)((0, _get2["default"])(this.data, 'hotel.location.country'), 'name', this.language);
    }

    /**
     * country code
     * @return {String}
     */
  }, {
    key: "countryCode",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.location.country.countryCode', '');
    }

    /**
     * property type
     * @return {String}
     */
  }, {
    key: "propertyTypeId",
    get: function get() {
      return (0, _get2["default"])(this.data, "hotel.propertyTypeId", '');
    }

    /**
     * hotel stars
     * @return {Number|undefined}
     */
  }, {
    key: "stars",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.starRating');
    }

    /**
     * hotel address
     * @return {String|undefined}
     */
  }, {
    key: "address",
    get: function get() {
      return (0, _language.translate2keysLabel)((0, _get2["default"])(this.data, 'hotel.location'), 'address', this.language);
    }

    /**
     * hotel images
     * @return {Array<Object>}
     */
  }, {
    key: "images",
    get: function get() {
      return (0, _hotelInfo.getImageCategories)((0, _get2["default"])(this.data, 'imageCategories', []), this.$env.config, this.isDev);
    }
    /**
     * hotel images
     * @return {Array<Object>}
     */
  }, {
    key: "categoriesImagesSize",
    get: function get() {
      var groupedById = (0, _groupBy2["default"])((0, _get2["default"])(this.data, 'imageCategories', []), 'imageGroupId');
      var result = (0, _mapValues2["default"])(groupedById, function (group) {
        var sizeImages = (0, _sumBy2["default"])(group, function (obj) {
          return obj.images.length;
        });
        return {
          sizeImages: sizeImages,
          data: group
        };
      });
      return result;
    }

    /**
     * hotel topPicks
     * @return {Object}
     * TODO: [enigma.missing]
     */
  }, {
    key: "topPick",
    get: function get() {
      return (0, _topPick.topPickFactory)((0, _get2["default"])(this.data, 'topPick', {}), this.language);
    }

    /**
     * latitude
     * @return {Number|undefined}
     */
  }, {
    key: "latitude",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.location.latitude');
    }

    /**
     * longitude
     * @return {Number|undefined}
     */
  }, {
    key: "longitude",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.location.longitude');
    }

    /**
     * video url
     * @return {String|undefined}
     *  todo: [enigma.missing][phase:2] video in hotel info
     */
  }, {
    key: "video",
    get: function get() {
      return (0, _get2["default"])(this.data, 'hotel.video');
    }

    /**
     * descriptions
     * @return {Array<Object>}
     */
  }, {
    key: "descriptions",
    get: function get() {
      return (0, _get2["default"])(this.data, 'descriptions', []);
    }

    /**
     * hotel descriptions
     * @return {Array<object>}
     */
  }, {
    key: "hotelDescriptions",
    get: function get() {
      return [this.generalDescription, this.locationDescription, this.diningDescription, this.roomsDescription, this.amenitiesDescription, this.businessAndOtherAmenitiesDescription].filter(function (section) {
        return (0, _get2["default"])(section, 'html.length') > 0;
      });
    }

    /**
     * general description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "generalDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.GENERAL_DESCRIPTION,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * location description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "locationDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.LOCATION,
        language: this.language,
        descriptions: this.descriptions
      });
    }
    /**
     * Spoken Languages description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "spokenLanguages",
    get: function get() {
      return (0, _aboutHotel.formatSpokenLanguages)({
        enTitle: _constants2.DESCRIPTION_TITLES.SPOKEN_LANGUAGES,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * dining description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "diningDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.DINING,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * rooms description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "roomsDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.ROOMS,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * amenities description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "amenitiesDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.AMENITIES,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * Business, and other amenities description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "businessAndOtherAmenitiesDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.BUSINESS_OTHER_AMENITIES,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * attractions description
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "attractionsDescription",
    get: function get() {
      return (0, _aboutHotel.formatDescriptionsContentSection)({
        enTitle: _constants2.DESCRIPTION_TITLES.ATTRACTIONS,
        language: this.language,
        descriptions: this.descriptions
      });
    }

    /**
     * descriptionMeta
     * @return {string}
     */
  }, {
    key: "descriptionMeta",
    get: function get() {
      var _descriptions$, _descriptions$3;
      var descriptions = (0, _get2["default"])(this.data, 'descriptions', []);
      if (this.language === 'en' && (_descriptions$ = descriptions[0]) !== null && _descriptions$ !== void 0 && _descriptions$.descriptionEn) {
        var _descriptions$2;
        return (0, _hotel.getTextFromHtml)((_descriptions$2 = descriptions[0]) === null || _descriptions$2 === void 0 ? void 0 : _descriptions$2.descriptionEn);
      }
      if (this.language === 'ar' && (_descriptions$3 = descriptions[0]) !== null && _descriptions$3 !== void 0 && _descriptions$3.descriptionAr) {
        var _descriptions$4;
        return (0, _hotel.getTextFromHtml)((_descriptions$4 = descriptions[0]) === null || _descriptions$4 === void 0 ? void 0 : _descriptions$4.descriptionAr);
      }
      return '';
    }

    /**
     * policies
     * @return {Array<Object>}
     */
  }, {
    key: "policies",
    get: function get() {
      return (0, _get2["default"])(this.data, 'policies', []);
    }

    /**
     * policies section
     * @return {Array<{id, title, html}>}
     */
  }, {
    key: "policiesSection",
    get: function get() {
      return [this.checkInDescription, this.checkInInstructions, this.checkInSpecialInstructions];
    }

    /**
     * has checkin instructions
     * @return {Boolean}
     */
  }, {
    key: "hasCheckinInstructions",
    get: function get() {
      return (0, _flatMap2["default"])(this.policiesSection, 'html').some(Boolean);
    }

    /**
     * showHotelDescriptions
     * @return {Boolean}
     */
  }, {
    key: "showHotelDescriptions",
    get: function get() {
      return (0, _get2["default"])(this.hotelDescriptions, 'length') > 0;
    }

    /**
     * showPoliciesDescriptions
     * @return {Boolean}
     */
  }, {
    key: "showPoliciesDescriptions",
    get: function get() {
      return [this.policies.every(function (policy) {
        return Object.values((0, _omit2["default"])(policy, 'id')).every(Boolean);
      })].concat((0, _toConsumableArray2["default"])(this.importantInformation), (0, _toConsumableArray2["default"])(this.feesAndExtras)).some(Boolean);
    }

    /**
     * showCheckInInstructions
     * @return {Boolean}
     */
  }, {
    key: "showCheckInInstructions",
    get: function get() {
      return (0, _get2["default"])([this.checkInInstructions], 'length') > 0;
    }

    /**
     * showImportantInformation
     * @return {Boolean}
     */
  }, {
    key: "showImportantInformation",
    get: function get() {
      return (0, _get2["default"])(this.importantInformation, 'length') > 0;
    }

    /**
     * showFeesAndExtras
     * @return {Boolean}
     */
  }, {
    key: "showFeesAndExtras",
    get: function get() {
      return (0, _get2["default"])(this.feesAndExtras, 'length') > 0;
    }

    /**
     * important information
     * @return {Array<{id, title, html}>}
     */
  }, {
    key: "importantInformation",
    get: function get() {
      return [this.youNeedToKnow].filter(function (section) {
        return (0, _get2["default"])(section, 'html.length') > 0;
      });
    }

    /**
     * fees and extras
     * @return {Array<{id, title, html}>}
     */
  }, {
    key: "feesAndExtras",
    get: function get() {
      return [this.mandatoryFees, this.optionalFees].filter(function (section) {
        return (0, _get2["default"])(section, 'html.length') > 0;
      });
    }

    /**
     * has fees and extras
     * @return {boolean}
     */
  }, {
    key: "hasFeesAndExtras",
    get: function get() {
      return (0, _flatMap2["default"])(this.feesAndExtras, 'html').some(Boolean);
    }

    /**
     * attractions
     * @return {Object}
     */
  }, {
    key: "attractions",
    get: function get() {
      var nearestAirportsTitle = this.isRtl ? 'أقرب المطارات هو:' : 'The nearest airports are:';
      return (0, _aboutHotel.formatAttractionsContent)({
        nearestAirportsTitle: nearestAirportsTitle,
        attractionsDescription: (0, _get2["default"])(this.attractionsDescription, 'html', '')
      });
    }

    /**
     * you need to know
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "youNeedToKnow",
    get: function get() {
      return (0, _aboutHotel.formatPolicyContentSection)({
        id: 1,
        language: this.language,
        policies: this.policies
      });
    }

    /**
     * mandatory fees
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "mandatoryFees",
    get: function get() {
      return (0, _aboutHotel.formatPolicyContentSection)({
        id: 2,
        language: this.language,
        policies: this.policies
      });
    }

    /**
     * optional fees
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "optionalFees",
    get: function get() {
      return (0, _aboutHotel.formatPolicyContentSection)({
        id: 3,
        language: this.language,
        policies: this.policies
      });
    }

    /**
     * checkin instructions
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "checkInInstructions",
    get: function get() {
      return (0, _aboutHotel.formatPolicyContentSection)({
        id: 4,
        language: this.language,
        policies: this.policies
      });
    }

    /**
     * checkin special instructions
     * @return {{title: string, html: string, id: number}}
     */
  }, {
    key: "checkInSpecialInstructions",
    get: function get() {
      return (0, _aboutHotel.formatPolicyContentSection)({
        id: 5,
        language: this.language,
        policies: this.policies
      });
    }
    /**
     *
     */
  }, {
    key: "checkInDescription",
    get: function get() {
      return (0, _aboutHotel.formatCheckInDescription)((0, _get2["default"])(this.data, 'hotel', {}));
    }

    /**
     * hotel amenities
     * @return {Array}
     */
  }, {
    key: "hotelAmenitiesIds",
    get: function get() {
      return (0, _get2["default"])(this.data, 'facilityCategories', []);
    }

    /**
     * has maldives transfer
     * @return {boolean}
     */
  }, {
    key: "hasTransfer",
    get: function get() {
      return (0, _get2["default"])(this.data, 'transfer', null) ? true : false;
    }

    /**
     * maldives transfer
     * @return {boolean}
     */
  }, {
    key: "maldivesTransfer",
    get: function get() {
      return this.hasTransfer ? (0, _aboutHotel.formatMaldivesTransfer)({
        data: (0, _get2["default"])(this.data, 'transfer', null),
        currency: this.$env.currency,
        formatPrice: this.$env.currency.formatPrice
      }) : {};
    }

    /**
     * isMaldives
     * @return {boolean}
     */
  }, {
    key: "isMaldives",
    get: function get() {
      return this.countryCode === _constants2.MALDIVES_COUNTRY_CODE;
    }

    /**
     * is transfer online
     * @return {boolean}
     */
  }, {
    key: "isTransferOnline",
    get: function get() {
      return this.hasTransfer && this.maldivesBaseLowestPrice > 0;
    }

    /**
     * is transfer free
     * @return {boolean}
     */
  }, {
    key: "isTransferFree",
    get: function get() {
      return this.hasTransfer && this.maldivesBaseLowestPrice === 0;
    }

    /**
     * maldives transfer lowest adult price
     * @return {boolean}
     */
  }, {
    key: "maldivesAdultLowestPrice",
    get: function get() {
      return this.hasTransfer && this.maldivesTransfer && Object.keys(this.maldivesTransfer).length > 0 && (0, _aboutHotel.getAdultLowestPrice)({
        data: this.maldivesTransfer
      });
    }

    /**
     * maldives transfer lowest base price
     * @return {boolean}
     */
  }, {
    key: "maldivesBaseLowestPrice",
    get: function get() {
      return !(0, _get2["default"])(this.data, 'transfer', null) ? null : Number((0, _aboutHotel.getAdultLowestPrice)({
        data: (0, _get2["default"])(this.data, 'transfer', null)
      }));
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param {Object} data
     */
    function onSuccess(data) {
      this.data = data;
      this.API_STATE = _constants.API_STATE.SUCCESS;
    }

    /**
     * handle error
     * @param {Object} error
     * @param {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      errorHandler((0, _error["default"])({
        error: error,
        language: this.language
      }));
      this.API_STATE = _constants.API_STATE.FAILED;
    }

    /**
     * Reset API State
     */
  }, {
    key: "resetApiState",
    value: function resetApiState() {
      this.data = {};
      this.API_STATE = _constants.API_STATE.INITIAL;
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.API_STATE.INITIAL;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "language", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.$env.config.language;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isRtl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.$env.config.isRtl;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isDev", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.$env.config.isDev;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hotelId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotelId"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "FAQ", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "FAQ"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasFAQs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFAQs"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "name", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "email", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "phone", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "phone"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "metaTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "metaTitle"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "chainId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "chainId"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "city", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "city"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasArabicSpokenStaff", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasArabicSpokenStaff"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "country", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "country"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "countryCode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "countryCode"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "propertyTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "propertyTypeId"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stars", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "stars"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "address", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "address"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "images", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "images"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "categoriesImagesSize", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "categoriesImagesSize"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "topPick", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPick"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "latitude", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "latitude"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "longitude", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "longitude"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "video", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "video"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "descriptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "descriptions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hotelDescriptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotelDescriptions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "generalDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "generalDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "locationDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "spokenLanguages", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "spokenLanguages"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "diningDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "diningDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "roomsDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "roomsDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "amenitiesDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amenitiesDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "businessAndOtherAmenitiesDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "businessAndOtherAmenitiesDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "attractionsDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "attractionsDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "descriptionMeta", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "descriptionMeta"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "policies", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "policies"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "policiesSection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "policiesSection"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasCheckinInstructions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCheckinInstructions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showHotelDescriptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHotelDescriptions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showPoliciesDescriptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPoliciesDescriptions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showCheckInInstructions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCheckInInstructions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showImportantInformation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showImportantInformation"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showFeesAndExtras", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showFeesAndExtras"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "importantInformation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "importantInformation"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "feesAndExtras", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "feesAndExtras"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasFeesAndExtras", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFeesAndExtras"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "attractions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "attractions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "youNeedToKnow", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "youNeedToKnow"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "mandatoryFees", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mandatoryFees"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "optionalFees", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionalFees"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "checkInInstructions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInInstructions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "checkInSpecialInstructions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInSpecialInstructions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "checkInDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInDescription"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hotelAmenitiesIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotelAmenitiesIds"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasTransfer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTransfer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maldivesTransfer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "maldivesTransfer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isMaldives", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMaldives"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isTransferOnline", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTransferOnline"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isTransferFree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTransferFree"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maldivesAdultLowestPrice", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "maldivesAdultLowestPrice"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maldivesBaseLowestPrice", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "maldivesBaseLowestPrice"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "fetch", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function (_ref) {
      var _this = this;
      var hotelId = _ref.hotelId,
        timeout = _ref.timeout,
        _ref$errorHandler = _ref.errorHandler,
        errorHandler = _ref$errorHandler === void 0 ? function () {} : _ref$errorHandler,
        _ref$successHandler = _ref.successHandler,
        successHandler = _ref$successHandler === void 0 ? function () {} : _ref$successHandler;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this.API_STATE = _constants.API_STATE.LOADING;
              _context.next = 4;
              return _hotelDetails.HotelDetailsClient.getHotelInfo({
                hotelId: hotelId,
                timeout: timeout
              });
            case 4:
              res = _context.sent;
              _this.onSuccess(res);
              successHandler();
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              _this.onError(_context.t0, errorHandler);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      })();
    });
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetApiState", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "resetApiState"), _class.prototype), _class);